<p *ngIf="product.price > 700">
  <button (click)="notify.emit()">Notify Me !!!</button>
</p>